<template>
  <div>
    <v-dialog
      v-model="planDialog"
      width="600px">
      <div class="dialog-container">
        <div class="plan-header">
          <div class="info flex">
            <span>Api Log</span>
            <i
              class="el-icon-close"
              @click="changeDialog"></i>
          </div>
        </div>
        <div class="dialog-body">
          <div class="flex-content">
            <div class="flex-box">
              <div
                class="flex-info">
                <span>Created</span>
                <span>{{ data.created_at }}</span>
              </div>
              <div
                class="flex-info">
                <span>Type</span>
                <span>{{ data.type }}</span>
              </div>
              <div
                class="flex-info">
                <span>Request URL</span>
                <span>{{ data.request_url }}</span>
              </div>
              <div
                class="flex-info">
                <span>Reqeust Params</span>
                <span>{{ data.request_params }}</span>
              </div>
              <div
                class="flex-info">
                <span>Response Result</span>
                <span>{{ data.response_result }}</span>
              </div>
              <div
                class="flex-info">
                <span>Status</span>
                <span>{{ data.status }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'apiDetailDialog',
  components: {
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    value:{
      type:Boolean,
      default:false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      planDialog: false,
    }
  },
  watch: {
    value(val) {
      this.planDialog = val
    },
  },
  methods: {
    changeDialog() {
      this.planDialog = false
      this.$emit('input', this.planDialog)
    },
    ConfirmCoupon(){
      this.planDialog =false
      this.$emit('input', this.planDialog)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .dialog-body{
    padding: 15px;
    max-height: 800px;
    overflow-y: auto;
  }
  .footer-button{
    padding: 15px;
    justify-content: space-between;
  }
  .flex-content {
    //width: 280px;
    .flex-box {
      border-radius: 5px;
      border: 1px solid #E1E4E8;
      //width: 280px;
      margin: 16px 0;

      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 23px 15px;
        border-bottom: 1px solid #E1E4E8;

        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight: 500;
          flex: 1;
          width: 30%;
        }

        span:last-child {
          color: #24292E;
          font-size: 14px;
          flex: 2;
          word-break: break-all;
          width: 70%;
        }
        &:last-child{
          border-bottom: 0;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
      }
      .transa-color{
        span{
          color: rgb(205,43,56)!important;
        }

      }

      .amount {
        color: #24292E;
        font-weight: bolder;
      }
    }
  }
}
</style>
